import pkg from "../../package.json";
const config = {
    app: {
        title: "بازیگرام",
        version: pkg.version,
        security: {
            routeKey: "baziigramReduxKey",
        },
        database: {
            version: 1,
            name: "baziigram-db"
        },
        service: {
            baseUrl: process.env.BASE_URL,
            timeout: "40000",
            apiUrls: {
                 GetGamesList:"Market/v1/GameList",
                 GameOffers:"Market/v1/GameOffers",
                RecordSiteView:"Market/v1/VisitLog",
                ReleaseUser:"Market/v1/ReleaseUser",
                GetBanners:"Market/v1/Banners",
                GetDeveloperInfo:"Developer/v1/GetDeveloperInfo",
                GetNews:"/GetNews",
                GetAchievements:"Game/v1/Achievements",
                GetLevels:"Game/v1/Levels",
                GetLevelInfo:"Game/v1/LevelInfo",
                BuyAchievement:"Game/v1/BuyAchievement",
                GameUserLogin:"v1/User/Game/OTPRequest",
                GameUserVerify:"v1/User/Game/Game/RegisterVerify",
                GameEditProfile:"Market/v1/EditProfile",
                GetGameUserProfile:"Market/v1/UserProfile",
                GetLeaderboard:"Game/v1/Leaderboard",
                GetUserPrizes:"Market/v1/UserAwards",
                GetAwardsList:"Market/v1/AvailableAwards",
                GetPrize:"Market/v1/ConfirmAward",
                GetGroups:"Game/v1/Groups",
                GetJoinRequests:"Game/v1/Group/JoinRequests",
                CreateNewGroup:"Game/v1/Group/CreateGroup",
                GetChats:"Game/v1/Group/Chats",
                NotifyAdmin:"NotifyAdmin",
                GameAlternativeLog:"Game/v1/AlternativeLog",
                RefreshToken:"v1/User/Game/RefreshToken",
                AdsLog:"Market/v1/AdsLog",
                GetGameCategories:"Market/v1/Categories",
                FCMToken:"Market/v1/FCMToken"


            },
        },
    },
};

export default config;
